"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Head = void 0;

var React = __importStar(require("react"));

var core_1 = require("@emotion/core");

var utils_1 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

var theme_1 = require("../../theme");

exports.Head = utils_1.forwardRef(function Head(props, ref) {
  var level = props.level,
      fontWeight = props.fontWeight,
      rest = __rest(props, ["level", "fontWeight"]);

  var _level = level || '1';

  var _fontWeight = fontWeight || '600';

  var sizes = theme_1.useTheme().sizes;
  var style = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t--hdg-font-size-1: ", ";\n\t\t--hdg-font-size-2: ", ";\n\t\t--hdg-font-size-3: ", ";\n\t\t--hdg-font-size-4: ", ";\n\t\t--hdg-font-size-5: ", ";\n\t\t--hdg-font-size-6: ", ";\n\n\t\t--hdg-font-size: var(--hdg-font-size-", ");\n\n\t\t--hdg-color: ", ";\n\n\t\tfont-family: 'Mont', sans-serif;\n\t\tfont-style: normal;\n\t\tfont-weight: ", ";\n\t\tfont-size: var(--hdg-font-size);\n\t\tcolor: var(--hdg-color);\n\t"], ["\n\t\t--hdg-font-size-1: ", ";\n\t\t--hdg-font-size-2: ", ";\n\t\t--hdg-font-size-3: ", ";\n\t\t--hdg-font-size-4: ", ";\n\t\t--hdg-font-size-5: ", ";\n\t\t--hdg-font-size-6: ", ";\n\n\t\t--hdg-font-size: var(--hdg-font-size-", ");\n\n\t\t--hdg-color: ", ";\n\n\t\tfont-family: 'Mont', sans-serif;\n\t\tfont-style: normal;\n\t\tfont-weight: ", ";\n\t\tfont-size: var(--hdg-font-size);\n\t\tcolor: var(--hdg-color);\n\t"])), sizes['18'], sizes['12'], sizes['8'], sizes['7'], sizes['6'], sizes['5'], _level, foundation_1.colors.secondary.darkGrey, _fontWeight);
  var Heading = lseds_1.lseds("h" + props.level);
  return (0, _core.jsx)(Heading, _extends({
    ref: ref,
    css: style
  }, rest), props.children);
});
var templateObject_1;